/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ChecklistDropdown200,
  GetApiV1ChecklistDropdown401,
  GetApiV1ChecklistDropdown500,
  GetApiV1ChecklistDropdownQueryResponse,
} from "../../types/checkListRegistroController/GetApiV1ChecklistDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ChecklistDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ChecklistDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ChecklistDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ChecklistDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistDropdown500>;

export const getApiV1ChecklistDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ChecklistDropdown200Schema,
) as unknown as ToZod<GetApiV1ChecklistDropdownQueryResponse>;
